import { render } from "./OrderSelect.vue?vue&type=template&id=56408ddf"
import script from "./OrderSelect.vue?vue&type=script&lang=js"
export * from "./OrderSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__